module.exports = __webpack_public_path__ + "img/Rogue-orc-m-70.889abb36.gif";